import * as ActionType from '../../constants/constant_action_types';
import * as TransactionStatus from '../../constants/constant_transaction_status';


const INITIAL_STATE = {
  data           : {
    status: { _id: TransactionStatus.OPEN },
    exchange_rate : 1
  },
  modal          : {
    state : 'hide',
    header: '',
    index : 0
  },
  generate_return: false
};

export default function purchaseReceiptReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_PURCHASE_RECEIPT: {
      return {
        ...state, data: { ...action.data }
      };
    }

    case ActionType.CLEAR_PURCHASE_RECEIPT: {
      return {
        ...INITIAL_STATE
      }
    }

    case ActionType.GENERATE_PURCHASE_RETURN: {
      return {
        ...state, generate_return: action.generateReturn
      }
    }

    case ActionType.OPEN_PURCHASE_RECEIPT_REFERENCE_ID_MODAL: {
      return {
        ...state, modal: {
          state : action.state,
          header: action.header,
          index : action.index
        }
      }
    }

    default:
      return state;
  }
}